<div class="flex flex-col justify-center items-center  ">
  <div class="font-bold pb-1 md:pb-6">Đọc thử</div>
  <div class="relative flex items-center justify-center">
    <div [closeOnOutSide]="isDropdown" (clickedOutside)="closeDropdown()" (click)="openDropdown()"
      class="relative flex items-center justify-center cursor-pointer">
      <div class="absolute px-4 right-0 -mt-1">
        <fa-icon class="-mt-1 text-gray-500" [icon]="faIcon"></fa-icon>
      </div>
      <ng-content></ng-content>
    </div>
    <div *ngIf="isDropdown" class="shadow-dropdown absolute top-8 border-gray-100 border rounded-md text-gray-500 bg-white z-50 w-full">
      <div
        (click)="action.emit({type: 'addItem', group: 'freeChapters', index: index, bookId: book.bookId, title: book.title, priceId: null, discountId: null, firstMoney: book.money, endDate: null})"
        class="cursor-pointer hover:bg-green-100 hover:flex px-4 items-center w-full py-1.5">
        <div class="pr-2">Nhập số chương</div>
        <fa-icon class="text-gray-500 " [icon]="faPen"></fa-icon>
      </div>
      <div *ngFor="let setFreeChapter of setFreeChapters" class="flex items-center relative">
        <div class="cursor-pointer hover:bg-green-100 hover:flex px-4 items-center w-full py-1.5">
          <div
            (click)="action.emit({type: 'selectEvent', group: 'freeChapters', index: index, bookId: book.bookId, title: book.title, priceId: null, discountId: null, freeChapters: setFreeChapter.value, firstMoney: book.money, endDate: null})"
            class="pr-1">
            {{setFreeChapter.text}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>